import type {InterfaceStrings} from './strings'

export const zh: InterfaceStrings = {
    nav: {
        beginSession: '开始',
        faq: '常见问题',
        pricing: '价格',
        legal: '法律信息',
        signIn: '登录',
        viewPricing: '查看价格',
        signOut: '退出登录',
        account: '账户',
        menu: '菜单',
        closeMenu: '关闭菜单',
        mainNav: '主导航',
        sessions: {other: '{n} 次引导'},
    },
    footer: {
        selfHypnosisFor: '自我催眠',
        anxiety: '缓解焦虑',
        sleep: '改善睡眠',
        stress: '释放压力',
        confidence: '建立自信',
        focus: '提升专注',
        learn: '了解方法',
        ericksonian: '什么是艾瑞克森催眠',
        aiHow: 'AI 催眠如何运作',
        vsMeditation: '催眠与冥想',
        methods: '方法',
        languages: '语言',
    },
    page: {
        cta: '开始你的免费引导',
        hint: '第一次引导免费',
        exploreFurther: '延伸阅读',
        disclaimer:
            'Quies 是一款用于放松与自我探索的身心健康工具，不是医疗器械，不诊断、治疗或治愈任何疾病。如果你正处于心理危机之中，请联系专业人士。',
        transcript: '文字稿',
        transcriptNote: '一段真实 Quies 引导的节选，按原样朗读。',
        breadcrumb: '导航路径',
    },
    pricing: {
        selectPlan: '选择此套餐',
        subscribe: '订阅',
        perMonth: '/ 月',
        manageSubscription: '管理订阅',
        replayFree: '重听过去的引导永远免费。',
        offerLead: '每一次引导，都从上一次结束的地方开始。',
    },
    session: {
        chooseLanguage: '选择你的语言',
        changeLanguage: '更换语言',
        changeVoice: '更换声音',
        previewVoice: '试听 {voice}',
        stopPreview: '停止试听',
        continue: '继续',
        composing: 'Quies 正在写你的引导',
        preparing: '正在准备你的冥想',
        pickingUp: '从你上次停下的地方继续',
        today: '今天',
        yesterday: '昨天',
        loading: '加载中…',
        showEarlier: '显示更早的内容（{count}）',
        tryDifferentApproach: '换一条路',
        nothingAdded: '未补充内容',
        purchaseConfirmed: '购买成功',
        firstSessionNote: '你的第一次引导免费。收听之前，需要先登录。',
    },
    threshold: {
        title: '登录后收听',
        message: '你的第一次引导免费，无需银行卡。',
        google: '使用 Google 继续',
        sendLink: '给我发送登录链接',
        sending: '发送中…',
        emailLabel: '邮箱地址',
        or: '或',
        waitingTitle: '请查收邮件',
        waitingBody: '我们已向 {email} 发送了登录链接。',
        sendAgain: '重新发送',
        googleInstead: '改用 Google 登录',
        codeLabel: '或输入邮件中的 6 位验证码',
        codeSubmit: '继续',
        codeSubmitting: '正在验证…',
        codeWrong: '验证码不正确。',
        codeDead: '此验证码已失效。请使用邮件中的链接，或重新发送。',
        errors: {
            invalidEmail: '请输入有效的邮箱地址。',
            rateLimited: '尝试次数过多，请几分钟后再试。',
            sessionError: '登录出了问题，请刷新页面后重试。',
            sendFailed: '邮件未能发出，请重试。',
            sessionExpired: '登录已过期，请刷新页面后重试。',
            generic: '出了点问题，请重试。',
        },
    },
    player: {
        play: '播放',
        pause: '暂停',
        playAgain: '再听一遍',
        seek: '进度',
        eyesClosed: '闭上眼睛',
        openEyes: '睁开眼睛',
        paused: '已暂停',
        unavailable: '音频不可用',
        untitled: 'Quies 引导',
    },
    failure: {
        turnFailed: '我们这边出了点问题。你的回答已保留。',
        reconnecting: '正在重新连接…',
        refusalTitle: '换一条路吧',
        refusal: '你的消息中有一部分无法回应。换个说法试试，或者再发送一次。',
        openElsewhere: '这次引导也在另一个窗口中打开着。',
        serviceDown: '暂时无法连接 Quies。你所做的一切都没有丢失。',
        sessionsUsedTitle: '你的引导次数已经用完',
        voiceFailedTitle: '你的冥想已经写好',
        voiceFailed: '暂时无法为它生成声音。什么都没有丢失，重新朗读不另收费。',
        voiceStopped: '声音在中途停了下来。可以从停下的地方继续。',
        streamMissing: '你的冥想已经准备好，但没有送达这个页面。',
        tapToListen: '轻触收听',
        fileFailed: '这段录音无法播放。可以免费为这段冥想重新朗读。',
        recordingGone: '这段录音已不再保存。',
        purchaseCancelled: '购买已取消，未产生任何扣款。',
        purchasePending: '你的付款已确认。引导次数到账比平时慢一些。',
        checkoutFailed: '付款未能完成，未产生任何扣款。',
        sessionEnded: '这次引导已经结束。',
        busy: 'Quies 此刻请求较多。你的回答已保留，请一分钟后再试。',
        tooLong: '这次引导已经长到 Quies 无法容纳，已退还给你。',
        notSaved: '这一步未能保存。请再试一次，以保留你的进度。',
        meditationRefused: '这段冥想无法按要求写出。换个说法，或者重新开始：这次引导将退还给你。',
        meditationRefusedUncharged: '这段冥想无法按要求写出。换个说法，或者重新开始。',
        linkExpired: '你的登录链接已过期，请重新获取。',
        oauthFailed: '登录被中断，请重试。',
        offline: '你目前处于离线状态。恢复连接后，你的回答会立即发送。',
        voiceChanged: '你选择的声音已不可用，这段冥想将由另一个声音朗读。',
        voiceReturned: '仍然无法生成声音。这次引导已退还给你。',
        voiceFailedAgain: '仍然无法生成声音。',
        voiceResuming: '声音正在恢复…',
        voiceLimited: '这一小时内已经为你朗读了好几段冥想。请稍后再试。',
        tryAgain: '重试',
        rephrase: '换个说法',
        resume: '接着播放',
        voiceAgain: '重新朗读',
        listen: '收听',
        continue: '继续',
        begin: '开始一次引导',
        signIn: '登录',
        checkAgain: '再次查看',
        sendLink: '发送登录链接',
        useEmail: '改用邮箱',
    },
}
